import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Search, ShoppingBag, BadgeCheck } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Shop() {
  const { t } = useI18n();
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    const params = q.trim() ? { q: q.trim() } : {};
    const { data } = await api.get("/products", { params });
    setProducts(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 py-10">
      <div className="flex items-end justify-between flex-wrap gap-6">
        <div>
          <p className="overline mb-3">{t("nav.shop")}</p>
          <h1 className="h-display text-5xl">{t("shop.title")}</h1>
          <p className="text-[#4A4A4A] mt-2 max-w-xl">{t("shop.subtitle")}</p>
        </div>
        <form onSubmit={(e)=>{e.preventDefault(); load();}} className="flex gap-2" data-testid="shop-search-form">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A8A8A]" size={16}/>
            <input value={q} onChange={(e)=>setQ(e.target.value)} className="input pl-9" placeholder="Search products" data-testid="shop-search-q" />
          </div>
          <button className="btn-primary" data-testid="shop-search-submit">Search</button>
        </form>
      </div>

      {products.length === 0 ? (
        <div className="card p-12 mt-10 text-center" data-testid="shop-empty">
          <ShoppingBag className="mx-auto mb-4 text-[#8A8A8A]" size={28}/>
          <p className="font-heading text-2xl">The shelves are warming up.</p>
          <p className="text-[#4A4A4A] mt-2">Hoomanz are uploading their first drops — be one of them.</p>
          <Link to="/profile/edit" className="btn-primary mt-6 inline-flex" data-testid="shop-empty-cta">Sell something on Hoomanz</Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-10" data-testid="shop-grid">
          {products.map(p => (
            <Link key={p.id} to={`/shop/${p.id}`} className="card overflow-hidden block group" data-testid={`product-card-${p.id}`}>
              <div className="relative aspect-square bg-[#F2F2F0]">
                {p.image && <img src={p.image} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>}
              </div>
              <div className="p-5">
                <p className="overline text-[#0057FF] mb-1">{p.product_type === "digital" ? "Digital" : p.product_type}</p>
                <h3 className="font-heading text-lg leading-tight line-clamp-2">{p.title}</h3>
                <div className="mt-4 flex items-center justify-between">
                  <div className="flex items-center gap-2 text-xs text-[#4A4A4A] min-w-0">
                    {p.hooman?.avatar && <img src={p.hooman.avatar} alt="" className="h-6 w-6 rounded-full object-cover"/>}
                    <span className="truncate">{p.hooman?.name}</span>
                    {p.hooman?.is_verified && <BadgeCheck size={12} className="text-[#0A0A0A] shrink-0"/>}
                  </div>
                  <span className="font-heading text-lg">${p.price}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
